// extracted by mini-css-extract-plugin
module.exports = {"SeriesTab":"SeriesTab_SeriesTab__NxuRE"};